import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import QuickOrderTableRow from './QuickOrderTableRow.vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickOrderTable',
  props: {
    allowPurchase: { type: Boolean },
    searchResults: null,
    asyncDone: null,
    dateSort: { type: Boolean },
    isUsMarket: { type: Boolean }
  },
  setup(__props: any) {



const showStock = computed<boolean>(() => store.getters['app/showStock']);
const hideB2BPrices = computed(() => store.getters['hideb2bprices/hideB2BPrices']);
const isQuoteBasketVisible = computed(() => store.getters['app/isQuoteBasketVisible']);

return { __sfc: true,showStock, hideB2BPrices, isQuoteBasketVisible, QuickOrderTableRow }
}

})